export function theme(){
  let num = 0;
  if(localStorage.getItem("theme") !== undefined && localStorage.getItem("theme") !== null){
    num = parseInt(localStorage.getItem("theme"));
  }
  if(num === 1){
    return 'success';
  }else if(num === 2){
    return 'info';
  }else if(num === 3){
    return 'warning';
  }else if(num === 4){
    return 'danger';
  }else if(num === 5){
    return 'secondary';
  }else if(num === 6){
    return 'dark';
  }else{
    return 'primary';
  }
}

export function themeColor(){
  let num = 0;
  if(localStorage.getItem("theme") !== undefined && localStorage.getItem("theme") !== null){
    num = parseInt(localStorage.getItem("theme"));
  }
  if(num === 1){
    return '#28a745';
  }else if(num === 2){
    return '#17a2b8';
  }else if(num === 3){
    return '#ffc107';
  }else if(num === 4){
    return '#dc3545';
  }else if(num === 5){
    return '#6c757d';
  }else if(num === 6){
    return '#343a40';
  }else{
    return '#007bff';
  }
}

export function createFormData(object) {
  let formData = '';
  Object.keys(object).forEach(key => formData += key+'='+encodeURI(object[key])+'&');
  return formData.substring(0,formData.length-1);
}

export function createFormData2(object) {
  const formData = new FormData();
  Object.keys(object).forEach(key => formData.append(key, object[key]));
  return formData;
}

export function sortObj(list, key, order, providedType) {
  function compare(a, b) {
      a = a[key];
      b = b[key];
      var type = 'string';
      if(providedType !== undefined && providedType !== null){
        type = providedType;
      }else{
        type = (typeof(a) === 'string' ||
                  typeof(b) === 'string') ? 'string' : 'number';
      }
      var result;
      if(order === false){
        if (type === 'string') result = b.localeCompare(a);
        else result = b - a;
      }else{
        if (type === 'string') result = a.localeCompare(b);
        else result = a - b;
      }
      return result;
  }
  return list.sort(compare);
}

export function getMonthLong(month){
  if(month == 1){
      return "January";
  }else if(month == 2){
      return "February";
  }else if(month == 3){
      return "March";
  }else if(month == 4){
      return "April";
  }else if(month == 5){
      return "May";
  }else if(month == 6){
      return "June";
  }else if(month == 7){
      return "July";
  }else if(month == 8){
      return "August";
  }else if(month == 9){
      return "September";
  }else if(month == 10){
      return "October";
  }else if(month == 11){
      return "November";
  }else if(month == 12){
      return "December";
  }
}

export function getMonthShort(month){
  if(month == 1){
      return "Jan";
  }else if(month == 2){
      return "Feb";
  }else if(month == 3){
      return "Mar";
  }else if(month == 4){
      return "Apr";
  }else if(month == 5){
      return "May";
  }else if(month == 6){
      return "Jun";
  }else if(month == 7){
      return "Jul";
  }else if(month == 8){
      return "Aug";
  }else if(month == 9){
      return "Sept";
  }else if(month == 10){
      return "Oct";
  }else if(month == 11){
      return "Nov";
  }else if(month == 12){
      return "Dec";
  }
}

export function getInputFormattedDateFromString(str){
  const date = new Date(str);
  return getInputFormattedDate(date);
}

export function getInputFormattedDate(date){
  const month = (date.getMonth() + 1) < 10? '0'+(date.getMonth() + 1): (date.getMonth() + 1);
  const dd = date.getDate() < 10? '0'+date.getDate(): date.getDate();
  return date.getFullYear()+ "-" + month + "-" + dd;
}

export function getFormattedDate(obj){
  const date = new Date(obj);
  return date.getDate() + " " + getMonthShort(date.getMonth() + 1) + ", " +date.getFullYear();
}

export function getFormattedTime(obj){
  const date = new Date(obj);
  const mm = date.getMinutes() < 10? '0'+date.getMinutes(): date.getMinutes();
  const hh = date.getHours() < 10? '0'+date.getHours(): date.getHours();
  //return hh + ":" + mm;
  return "";
}

export function downloadReceipt(axios, receipt_id, invoice_id){
  axios.get(global.config.api_server+'receipt?task=download&id='+receipt_id+'&invoice='+invoice_id+'&token='+localStorage.getItem("token"))
  .then(res => {
    if(res.status === 200 && res.data.status === "success"){
      const url = global.config.asset_server+'/'+res.data.file;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    }
  });
}

export function downloadRefund(axios, refund_id, invoice_id){
  axios.get(global.config.api_server+'refund?task=download&id='+refund_id+'&invoice='+invoice_id+'&token='+localStorage.getItem("token"))
  .then(res => {
    if(res.status === 200 && res.data.status === "success"){
      const url = global.config.asset_server+'/'+res.data.file;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    }
  });
}

export function downloadInvoice(axios, invoice_id){
  axios.get(global.config.api_server+'invoice?task=download&id='+invoice_id+'&token='+localStorage.getItem("token"))
  .then(res => {
    if(res.status === 200 && res.data.status === "success"){
      const url = global.config.asset_server+'/'+res.data.file;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    }
  });
}

export function downloadProforma(axios, proforma_id){
  axios.get(global.config.api_server+'proforma?task=download&id='+proforma_id+'&token='+localStorage.getItem("token"))
  .then(res => {
    if(res.status === 200 && res.data.status === "success"){
      const url = global.config.asset_server+'/'+res.data.file;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    }
  });
}

export function downloadCredit(axios, credit_id, invoice_id){
  axios.get(global.config.api_server+'credit?task=download&id='+credit_id+'&invoice='+invoice_id+'&token='+localStorage.getItem("token"))
  .then(res => {
    if(res.status === 200 && res.data.status === "success"){
      const url = global.config.asset_server+'/'+res.data.file;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    }
  });
}